__turbopack_context__.v({
  "arrow": "case-carousel-module__rSJGvW__arrow",
  "carousel": "case-carousel-module__rSJGvW__carousel",
  "controls": "case-carousel-module__rSJGvW__controls",
  "counter": "case-carousel-module__rSJGvW__counter",
  "dot": "case-carousel-module__rSJGvW__dot",
  "pagination": "case-carousel-module__rSJGvW__pagination",
  "slide": "case-carousel-module__rSJGvW__slide",
  "track": "case-carousel-module__rSJGvW__track",
  "viewport": "case-carousel-module__rSJGvW__viewport",
});
